export const projectConstant = [
  {
    title: "1. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/7/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["css", "redux", "scss"],
  },
  {
    title: "2. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/231/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "ant-design"],
  },
  {
    title: "3. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/29/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "css", "scss", "redux", "ant-design"],
  },
  {
    title: "4. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/56/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "css", "scss", "redux", "ant-design"],
  },
  {
    title: "5. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/47/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["react", "ant-design", "css", "redux", "scss"],
  },
  {
    title: "6. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/22/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "css", "scss", "redux", "ant-design"],
  },
  {
    title: "7. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/95/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "scss", "redux", "ant-design"],
  },
  {
    title: "8. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/34/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "ant-design", "css", "scss"],
  },
  {
    title: "9. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/91/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "ant-design"],
  },
  {
    title: "10. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/67/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "css", "scss"],
  },
  {
    title: "11. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/200/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "ant-design", "css", "redux"],
  },
  {
    title: "12. Lorem Ipsum",
    imgSrc: "https://picsum.photos/id/39/120/120",
    previewLink: "#",
    codeLink: "#",
    technologies: ["javascript", "react", "css", "redux", "scss"],
  },
];
